import script from "./Sidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./Sidebar.vue?vue&type=script&setup=true&lang=js"

import "./Sidebar.vue?vue&type=style&index=0&id=7a4019fb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a4019fb"]])

export default __exports__